import React, { useEffect } from 'react'
import { Grid, IconButton, Typography, withStyles } from '@material-ui/core'
import { Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Icon from '@mdi/react'
import { mdiMessageQuestion } from '@mdi/js'

import styles from '../../../resources/theme/global'
import colors from '../../../assets/colors'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import { fetchKnowWay } from '../KnowWayActions'
import { getKnowWayListData } from '../KnowWayReducer'
import Filter from './Filter'
import List from './List'
import New from './New'
import Edit from './Edit'

const KnowWay = props => {
  const dispatch = useDispatch()
  const location = useLocation()

  const filters = useQueryParams(location?.search)

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate, canRead, canUpdate } = usePermissions()

  const { classes } = props

  useEffect(() => {
    const { pathname } = location
    dispatch(fetchKnowWay(filters, filters?.rows || 10, filters?.page || 1))
  }, [location])

  return (
    <Grid
      container
      className={classes.pageHead}
      spacing={1}
      alignItems="center"
    >
      <Grid item xs={12}>
        <Typography
          variant="h4"
          style={{ fontSize: '20px' }}
          color={colors.primary}
        >
          Como Conheceu
          <IconButton className={classes.questionBox}>
            <a href="" target="_blank" rel="noreferrer">
              <Icon
                path={mdiMessageQuestion}
                size={1}
                color={colors.secondary}
                style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                }}
              />
            </a>
          </IconButton>
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid container>
          <Filter classes={classes} />
        </Grid>
      </Grid>

      {canRead('como-conheceu', permissionUser) && (
        <Grid item xs={12}>
          <List classes={classes} />
        </Grid>
      )}

      {canCreate('como-conheceu', permissionUser) && (
        <Route path="/knowWay/New" component={New} />
      )}
      {canUpdate('como-conheceu', permissionUser) && (
        <Route path="/knowWay/:id/edit" component={Edit} />
      )}
    </Grid>
  )
}

export default withStyles(styles)(KnowWay)
